var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 7V0.46C14.9253 0.809335 15.7655 1.35131 16.4652 2.05L19.9492 5.536C20.6487 6.23488 21.1911 7.07489 21.5402 8H15.0002C14.735 8 14.4807 7.89464 14.2931 7.70711C14.1056 7.51957 14.0002 7.26522 14.0002 7ZM22.0002 10.485V19C21.9987 20.3256 21.4714 21.5964 20.534 22.5338C19.5967 23.4711 18.3258 23.9984 17.0002 24H7.00024C5.67465 23.9984 4.4038 23.4711 3.46646 22.5338C2.52913 21.5964 2.00183 20.3256 2.00024 19V5C2.00183 3.67441 2.52913 2.40356 3.46646 1.46622C4.4038 0.528882 5.67465 0.00158786 7.00024 0L11.5152 0C11.6782 0 11.8392 0.013 12.0002 0.024V7C12.0002 7.79565 12.3163 8.55871 12.8789 9.12132C13.4415 9.68393 14.2046 10 15.0002 10H21.9762C21.9872 10.161 22.0002 10.322 22.0002 10.485ZM16.0002 17C16.0002 16.7348 15.8949 16.4804 15.7074 16.2929C15.5198 16.1054 15.2655 16 15.0002 16H13.0002V14C13.0002 13.7348 12.8949 13.4804 12.7074 13.2929C12.5198 13.1054 12.2655 13 12.0002 13C11.735 13 11.4807 13.1054 11.2931 13.2929C11.1056 13.4804 11.0002 13.7348 11.0002 14V16H9.00024C8.73503 16 8.48067 16.1054 8.29314 16.2929C8.1056 16.4804 8.00024 16.7348 8.00024 17C8.00024 17.2652 8.1056 17.5196 8.29314 17.7071C8.48067 17.8946 8.73503 18 9.00024 18H11.0002V20C11.0002 20.2652 11.1056 20.5196 11.2931 20.7071C11.4807 20.8946 11.735 21 12.0002 21C12.2655 21 12.5198 20.8946 12.7074 20.7071C12.8949 20.5196 13.0002 20.2652 13.0002 20V18H15.0002C15.2655 18 15.5198 17.8946 15.7074 17.7071C15.8949 17.5196 16.0002 17.2652 16.0002 17Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileWhite);
export default __webpack_public_path__ + "static/media/add-file-white.9028f5642d14dc233b472401978149ed.svg";
export { ForwardRef as ReactComponent };